/**
 * Only to be used in WPO optimalisation
 */
import './components/observe';
